import React from 'react';
import { FluentDropdown } from '../../../../../components/FluentUI/Fluent-Dropdown';
import { makeStyles, shorthands } from '@fluentui/react-components';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  root: {
      display: "flex",
      padding: "7px",
      ...shorthands.border("1px", "solid", "#EEEEEE"),
      resize: "vertical !important",
      fontSize: "12px !important",
      color: "#4E4E4E",
      height: "36px",
      marginTop: "6px",
  },
});

function ProjectTemplateField({
    handleChange,
    projectTemplates,
    isEdit = false,
    value,
    labels
}) {
  const fieldStyle = useStyles();
  return (
    <FluentDropdown
      componentStyle={fieldStyle.root}
      label={`${labels?.ProjectSingular ?? "Project"} Template`}
      size={"small"}
      defaultValue={value || null}
      placeholder={`Select a ${labels?.ProjectSingular ?? "Project"} Template`}
      required={false}
      disabled={isEdit || projectTemplates.length === 0}
      options={projectTemplates}
      onChange={(e, option) => {handleChange('ParentTemplateName', option?.optionText ?? "");}}
      clearable={true}
    />
  )
}

ProjectTemplateField.propTypes = {
    handleChange: PropTypes.func.isRequired,
    projectTemplates: PropTypes.array.isRequired,
    isEdit: PropTypes.bool,
    value: PropTypes.string,
    labels: PropTypes.shape({
        ProjectSingular: PropTypes.string,
        ProjectPlural: PropTypes.string,
        ProjectSingularPossessive: PropTypes.string,
        ProjectPluralPossessive: PropTypes.string,
        TaskSingular: PropTypes.string,
        TaskPlural: PropTypes.string,
        TaskSingularPossessive: PropTypes.string,
        TaskPluralPossessive: PropTypes.string,
        FormSingular: PropTypes.string,
        FormPlural: PropTypes.string,
        FormSingularPossessive: PropTypes.string,
        FormPluralPossessive: PropTypes.string,
    }),
}

export default ProjectTemplateField;